import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@mui/material";
import {WheatIcon} from "../icon/WheatIcon";
import * as React from "react";

function DropInfo(props) {
  return (
          <div>
          <Typography marginTop={2} align={'center'} fontSize={16} fontWeight={500}>
            What are Drops and how do they work?
          </Typography>
          <Grid container justifyContent={'center'} spacing={1} marginTop={2} marginBottom={1} paddingLeft={{xs: '5%', sm: '8%', md: '10%', lg: '20%'}} paddingRight={{xs: '5%', sm: '8%', md: '10%', lg: '20%'}}>
            <Grid container direction={'row'} spacing={1}>
              <List sx={{marginLeft: '5%'}}>
                <ListItem dense={true}>
                  <ListItemIcon>
                    <WheatIcon />
                  </ListItemIcon>
                  <ListItemText sx={{fontStyle: 'italic', fontSize: 14, marginLeft: -2}}>
                    Drops are scheduled bread order pickup times
                  </ListItemText>
                </ListItem>
                <ListItem dense={true}>
                  <ListItemIcon>
                    <WheatIcon />
                  </ListItemIcon>
                  <ListItemText sx={{fontStyle: 'italic', fontSize: 14, marginLeft: -2}}>
                    Using the <a href={'https://www.hotplate.com/minnehaha.bread'} target={'_blank'} rel="noreferrer">Hotplate</a> service, I set a menu and take preorders
                  </ListItemText>
                </ListItem>
                <ListItem dense={true}>
                  <ListItemIcon>
                    <WheatIcon />
                  </ListItemIcon>
                  <ListItemText sx={{fontStyle: 'italic', fontSize: 14, marginLeft: -2}}>
                    Register once (“Never miss a drop”) to get a text when preorders go live
                  </ListItemText>
                </ListItem>
                <ListItem dense={true}>
                  <ListItemIcon>
                    <WheatIcon />
                  </ListItemIcon>
                  <ListItemText sx={{fontStyle: 'italic', fontSize: 14, marginLeft: -2}}>
                    I take requests... love getting requests!
                  </ListItemText>
                </ListItem>
                <ListItem dense={true}>
                  <ListItemIcon>
                    <WheatIcon />
                  </ListItemIcon>
                  <ListItemText sx={{fontStyle: 'italic', fontSize: 14, marginLeft: -2}}>
                    Preorders usually go live Monday evenings; pickup on Fridays
                  </ListItemText>
                </ListItem>
                <ListItem dense={true}>
                  <ListItemIcon>
                    <WheatIcon />
                  </ListItemIcon>
                  <ListItemText sx={{fontStyle: 'italic', fontSize: 14, marginLeft: -2}}>
                    Check the <a href={'/'}>home page</a>, updated weekly, to see the drop schedule
                  </ListItemText>
                </ListItem>
                <ListItem dense={true}>
                  <ListItemIcon>
                    <WheatIcon />
                  </ListItemIcon>
                  <ListItemText sx={{fontStyle: 'italic', fontSize: 14, marginLeft: -2}}>
                    First one is on the house! Discount code <b>WELCOME26</b>
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>
          </Grid>
          </div>
  )
}

export {DropInfo}